import { ViewModel, View, ObservableArray } from "binder"
import { WarehouseKeepingEditorView } from "./warehouseKeepingEditor-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { FileChooser, translate } from "src/common/utilities";
import { downloadFile } from "src/uicomponents/components/utilities";

export class WarehouseKeepingEditorViewModel extends ViewModel implements IPopup {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.productLineItems = ObservableArray.create<ProductLineItem>();
    }
    GetDefaultView(): View<ViewModel> {
        return new WarehouseKeepingEditorView();
    }
    public getTypeId(): string {
        return "VM-A0364C16-734E-4DBE-9E9D-60239E7124E4"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set productLineItems(v: ObservableArray<ProductLineItem>) { this._productLineItem = v; } public get productLineItems(): ObservableArray<ProductLineItem> { return this._productLineItem; } private _productLineItem: ObservableArray<ProductLineItem>;
    public set keepingId(v: string) { this._keepingId = v; } public get keepingId(): string { return this._keepingId; } private _keepingId: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId; } private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set state(v: number) { this._state = v; } public get state(): number { return this._state; } private _state: number;
    public set canFinalized(v: boolean) { this._canFinalized = v; } public get canFinalized(): boolean { return this._canFinalized; } private _canFinalized: boolean;
    public set canCounting(v: boolean) { this._canCounting = v; } public get canCounting(): boolean { return this._canCounting; } private _canCounting: boolean;


    closePopup(result: boolean = false) {

    }

    back() {
        this.closePopup(false);
    }


    async loadById(warehouseKeepingId: string): Promise<void> {
        try {
            this.isLoading = true;
            let severResult = await ServerConnection.callServer("/Complex/WarehouseKeepingServices/GetWarehouseKeepingData", {
                KeepingId: warehouseKeepingId
            });
            if (severResult.IsSuccessful == false) {
                this.messageBoxConfirmWarning('خطا در برقراری ارتباط با سرور', 'خطا');
                return;
            }
            let firstCounting: ObservableArray<any> = severResult.CountingList[0].Amounts;
            this.warehouseId = severResult.WarehouseId;
            this.warehouseName = severResult.WarehouseName;
            this.keepingId = severResult.KeepingId;
            this.state = severResult.Status;
            this.canFinalized = severResult.Status == 2 ? true : false;
            this.canCounting = severResult.Status == 1 ? true : false;
            this.productLineItems.update(...severResult.MeasuredProductInfo.map((q, i) => {
                let r = new ProductLineItem(this);
                r.index = i + 1;
                r.produtId = q.Id;
                r.productName = q.Name;
                r.productCode = q.Code;
                r.balance = q.Balance;
                r.accessibleBalance = q.AccessibleBalance;
                r.countedNumber = firstCounting.find(item => item.Id == q.Id).Count ?? q.Balance;
                return r;
            }));

        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async saveFirstCount() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/UpdateCountedAmounts', {
                KeepingId: this.keepingId,
                CountingNo: 1,
                ProductAmounts: this.productLineItems.map(item => {
                    return {
                        ProductId: item.produtId,
                        CountedAmount: item.countedNumber
                    }
                })
            });
            if (result.IsSuccessful) {
                await this.messageBoxConfirmSuccess('شمارش اولیه با موفقیت ذخیره شد.', ' ذخیره شمارش اولیه');
                this.closePopup(true);
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('خطا در برقراری ارتباط با سرور', 'خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async confirmFirstCount() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/FinalizeFirstCountingForWarehouseKeepingData', {
                KeepingId: this.keepingId
            });
            if (result.IsSuccessful) {
                await this.messageBoxConfirmSuccess('شمارش اولیه با موفقیت تایید شد.', ' تایید شمارش اولیه');
                this.closePopup(true);
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmSuccess('شمارش با موفقیت تایید شد.', ' تایید شمارش');
        } finally {
            this.isLoading = false;
        }
    }

    async finalConfirm() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/FinalizeAllCountingStagesForWarehouseKeeping', {
                KeepingId: this.keepingId
            });
            if (result.IsSuccessful) {
                await this.messageBoxConfirmSuccess(translate("warehouseKeepingDetail-viewModel.allCurrentCounts", {}), translate("warehouseKeepingDetail-viewModel.registerCount", {}));
                this.closePopup(true);
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning(translate("warehouseKeepingDetail-viewModel.serverError", {}), translate("warehouseKeepingDetail-viewModel.error", {}));
        } finally {
            this.isLoading = false;
        }
    }

    async downloadExcelFile() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/ExportKeepingDataAsExcelFile', {
                KeepingId: this.keepingId,
                CountNo: 1
            });
            downloadFile(result.ExcelFile, "Product List.xlsx");
            if (result.IsSuccessful) {
                await this.messageBoxConfirmSuccess("فایل اکسل با موفقیت دانلود شد.", "دانلود فایل اکسل");
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async uploadExcelFile() {
        try {
            let fileChooser = new FileChooser;
            let choosedFile = await fileChooser.chooseFile();
            let fileNameList = choosedFile.filename.split('.');
            let fileExtention = fileNameList[fileNameList.length - 1];
            if(fileExtention.toLowerCase() != 'xlsx'){
                await this.messageBoxConfirmWarning("فرمت فایل انتخاب شده صحیح نمی باشد.", "آپلود فایل اکسل");
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/UploadKeepingProductFromExcelFile', {
                KeepingId: this.keepingId,
                ExcelFile: choosedFile.fileContent
            });
            if(result.IsValidFile == false){
                downloadFile(result.ExcelFile, "Product List.xlsx");
                await this.messageBoxConfirmWarning("در فایل اپلود شده مقادیر به درستی وارد نشده است، لطفا دانلود های خود را چک کنید", "آپلود فایل اکسل");
                return;
            }
            this.productLineItems.update(...result.ProductLists.map((q, i) => {
                let r = new ProductLineItem(this);
                r.index = i + 1;
                r.produtId = q.MeasuredProductId;
                r.productName = q.ProductName;
                r.productCode = q.ProductCode;
                r.balance = q.Balance;
                r.accessibleBalance = q.AccessibleBalance;
                r.countedNumber = q.CountedNumber;
                return r;
            }));
            let productLength = this.productLineItems.length; 
            if (result.IsSuccessful) {
                await this.messageBoxConfirmSuccess(`تعداد ${productLength} کالا با موفقیت آپلود شد.`, "آپلود فایل اکسل");
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class ProductLineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set produtId(v: string) { this._produtId = v; } public get produtId(): string { return this._produtId; } private _produtId: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance; } private _balance: number;
    public set countedNumber(v: number) {
        this._countedNumber = v;
        this.status = (this.balance == this.countedNumber) ? "صحیح" : (this.balance > this.countedNumber) ? "کمبود" : "پیدا شده";
        this.difference = this.countedNumber - this.balance;
    } public get countedNumber(): number { return this._countedNumber; } private _countedNumber: number;
    public set reason(v: string) { this._reason = v; } public get reason(): string { return this._reason; } private _reason: string;
    public set difference(v: number) { this._difference = v; } public get difference(): number { return this._difference; } private _difference: number;
    public set status(v: string) { this._status = v; } public get status(): string { return this._status; } private _status: string;
    public set accessibleBalance(v: number) { this._accessibleBalance = v; } public get accessibleBalance(): number { return this._accessibleBalance; } private _accessibleBalance: number;

}